module.exports = __webpack_public_path__ + "img/TOCTemp7.05843693.png";